import React from "react";
import styled, { keyframes } from "styled-components";

const slide = keyframes`
  0% { transform: translateX(-100%); }
  100% { transform: translateX(250%); }
`;

const Track = styled.div`
  position: relative;
  width: 100%;
  height: 3px;
  background: ${props => props.trackColor || "rgba(0, 0, 0, 0.1)"};
  overflow: hidden;

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 40%;
    background: ${props => props.barColor || "#000000"};
    animation: ${slide} 1.3s ease-in-out infinite;
  }
`;

const LineLoader = ({ className, trackColor, barColor }) => {
  return <Track className={className} trackColor={trackColor} barColor={barColor} />;
};

export default LineLoader;
